import { render, staticRenderFns } from "./BaseFormPreview.vue?vue&type=template&id=224cd85c&scoped=true"
import script from "./BaseFormPreview.vue?vue&type=script&lang=js"
export * from "./BaseFormPreview.vue?vue&type=script&lang=js"
import style0 from "./BaseFormPreview.vue?vue&type=style&index=0&id=224cd85c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224cd85c",
  null
  
)

export default component.exports